/** The hotpot-studio.com footer, 1:1: about, email + Instagram, phones, and the HOTPOT picture. */
import { useT } from '../i18n.js';

export const STUDIO_EMAIL = 'hi@hotpot-studio.com';

export function SiteFooter() {
  const { lang } = useT();
  const base = import.meta.env.BASE_URL;
  return (
    <footer className="site-footer">
      <div className="columns">
        <p className="about">
          {lang === 'cs'
            ? 'Tvoříme strategické a výrazné vizuální identity z našeho studia v Praze. Stavíme na spolupráci, jasnosti, kreativitě a řemeslu.'
            : 'We craft strategic and distinctive brand identities from our studio in Prague. Rooted in collaboration and driven by clarity, creativity, and craft.'}
        </p>
        <p className="links">
          <a className="slide" href={`mailto:${STUDIO_EMAIL}`}>
            {STUDIO_EMAIL}
          </a>
          <br />
          <a className="slide" href="https://www.instagram.com/hot_pot_studio/" target="_blank" rel="noopener noreferrer">
            Instagram
          </a>
        </p>
        <p className="phones">
          <a className="slide" href="tel:+420774408452">
            +420 774 408 452
          </a>
          <br />
          <a className="slide" href="tel:+420725980718">
            +420 725 980 718
          </a>
        </p>
      </div>
      <a className="picture" href="https://hotpot-studio.com/" target="_blank" rel="noopener noreferrer" aria-label="Hotpot Studio">
        <img src={`${base}hotpot.webp`} srcSet={`${base}hotpot-800.webp 800w, ${base}hotpot.webp 2000w`} sizes="calc(100vw - 4rem)" alt="" width={2000} height={900} loading="lazy" decoding="async" />
      </a>
    </footer>
  );
}

export function LangSwitch() {
  const { lang, setLang } = useT();
  return (
    <div className="lang-switch" role="group" aria-label="Language / Jazyk">
      {(['cs', 'en'] as const).map((l) => (
        <button key={l} type="button" className={lang === l ? 'on' : ''} aria-pressed={lang === l} onClick={() => setLang(l)} lang={l} title={l === 'cs' ? 'Čeština' : 'English'}>
          {l === 'cs' ? 'CZ' : 'EN'}
        </button>
      ))}
    </div>
  );
}
